import { createFileRoute, redirect } from "@tanstack/react-router"
import { setupPathToSettings } from "~/utils/settingsArea"

// Keeps old Setup bookmarks working.
export const Route = createFileRoute("/_auth/setup")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: setupPathToSettings(location.href), replace: true })
  },
})
